import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  requestConfig,
  throwFromFailedResponse,
} from "../../globals";

export const updateWishlistTagProps = z
  .object({
    tag: z.number(),
    name: z.string(),
    token: z.string(),
  })
  .extend(requestConfig.shape);

export type UpdateWishlistTagProps = z.infer<typeof updateWishlistTagProps>;

export const updateWishlistTag = async (
  args: UpdateWishlistTagProps,
): Promise<void> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    tag,
    name,
    token,
    proxyAuthSecret,
  } = parseServiceInput(updateWishlistTagProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v3/wishlist/tag`, {
    method: "PATCH",
    headers,
    body: JSON.stringify({ name, id: tag }),
  });

  if (!response.ok) {
    await throwFromFailedResponse(response);
  }
  return;
};
